import { Trans } from "@lingui/react/macro";
import { Button, Modal, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconPlus } from "@tabler/icons-react";

import { GetLocationsItem } from "@/shared/api/generated/schemas";

import CreateEmployeeForm from "./create-employee-form";

export default function CreateEmployee({
  locations,
}: {
  locations?: GetLocationsItem[];
}) {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Button onClick={open} leftSection={<IconPlus />}>
        <Trans>Opprett personell</Trans>
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        size="lg"
        title={
          <Title size="sm">
            <Trans>Opprett personell</Trans>
          </Title>
        }
      >
        <CreateEmployeeForm close={close} availableLocations={locations} />
      </Modal>
    </>
  );
}
